<template>
  <div class="dialog-wrap">
    <el-dialog
      title="账号选择"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      @close="handleClose"
      append-to-body
      width="980px"
    >
      <div>
        <el-form
          class="search-wrap"
          ref="searchForm"
          :inline="true"
          :model="query"
          size="mini"
          label-position="left"
        >
          <el-form-item label="账号名称">
            <el-input
              v-model.trim="query.name_keyword"
              placeholder="输入账号名称"
              @input="fetchList(true)"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="院校学科">
            <el-input
              v-model.trim="query.college_major_keyword"
              placeholder="输入院校学科"
              @input="fetchList(true)"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="所属平台">
            <el-select
              v-model="query.platform_codes"
              clearable
              placeholder="请选择"
              style="width: 350px"
              @input="fetchList(true)"
            >
              <el-option
                label="小红书"
                :value="1"
              ></el-option>
              <el-option
                label="公众号"
                :value="2"
              ></el-option>
              <el-option
                label="微博"
                :value="3"
              ></el-option>
              <!--      <el-option
                label="B站"
                :value="4"
              ></el-option> -->
              <el-option
                label="知乎"
                :value="5"
              ></el-option>
              <!--         <el-option
                label="抖音"
                :value="6"
              ></el-option> -->
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <el-table
        class="table"
        :data="results"
        border
        style="width: 100%"
        @selection-change="handleSelectionChange"
        ref="multipleTable"
      >
        <el-table-column
          type="selection"
          width="50"
        > </el-table-column>
        <el-table-column
          prop="id"
          label="ID"
          width="80"
          align="center"
        >
        </el-table-column>
        <el-table-column
          label="类型"
          width="100"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{formateType_code(scope.row.type_code)}}
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="账号名称"
          width="160"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>

        <el-table-column
          label="院校学科"
          width="260"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{scope.row.college_name?scope.row.college_name:""}}
            {{scope.row.college_name&&scope.row.major_name?"/":""}}
            {{scope.row.major_code?`(${scope.row.major_code})${scope.row.major_name}`:""}}
          </template>
        </el-table-column>
        <!--    <el-table-column
          label="院校"
          width="260"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{scope.row.college_name?scope.row.college_name:"/"}}
          </template>
        </el-table-column>
        <el-table-column
          label="学科"
          width="260"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{scope.row.major_name?`(${scope.row.major_code})${scope.row.major_name}`:"/"}}
          </template>
        </el-table-column> -->
        <el-table-column
          label="所属平台"
          width="100"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{formatePlatform_code(scope.row.platform_code)}}
          </template>
        </el-table-column>
        <el-table-column
          prop="daily_require_count"
          label="每日要求"
          width="80"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="topic_count"
          label="选题数量"
          width="80"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="ready_publish_count"
          label="待发文案"
          width="80"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="today_publish_count"
          label="今日发布"
          width="80"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="total_publish_count"
          label="累计发布"
          width="80"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          width="300"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>

      </el-table>
      <div class="footer">
        <el-pagination
          background
          small
          layout="total, prev, pager, next,sizes, jumper"
          :current-page="Number(query.pageIndex)"
          :page-sizes="[10, 20, 50, 100, 500]"
          :page-size="Number(query.pageSize)"
          :total="Number(pageTotal)"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="handleClose">取 消</el-button>
        <el-button
          type="primary"
          @click="submit"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>



import { mediaaccountlist } from "@/api/select";



export default {
  components: {

  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    content: {
      type: Array,
      default: () => { [] },
    },
    pid: {
      type: Number,
      default: () => { },
    },
    type_codes: {
      type: Number,
      default: () => {
        return null
      }
    },
  },
  data() {
    return {
      dialogVisible: this.visible,
      results: [],
      pageTotal: 0,
      query: {
        pageIndex: 1,
        pageSize: 10,
        isPaging: 1,
      },
      createDatetime: "",
    };
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
      if (val) {
        this.fetchList();
      }
    },
    // 时间数据监听
    createDatetime(value) {
      if (value) {
        this.query.start_create_time = this.$moment(value[0]).valueOf();
        this.query.end_create_time = this.$moment(value[1]).valueOf();
      } else {
        this.query.start_create_time = "";
        this.query.end_create_time = "";
        this.fetchList(true)
      }
    },
    content(val) {
      this.selections = val
    },
    pid(val) {
      this.$set(this.query, 'topic_id', val)

    }

  },
  created() {

  },
  computed: {

  },
  methods: {
    // 科目列表请求
    fetchList(isReset = false) {
      this.$set(this.query, 'type_codes', this.type_codes)
      if (isReset) {
        this.$set(this.query, 'pageIndex', 1)
      }
      const param = Object.assign({}, this.query)
      mediaaccountlist(param).then((res) => {
        this.results = res.list || [];
        this.pageTotal = res.count;

        if (!this.single) {
          this.$nextTick(this.setRowSelection);
        }

      });
    },
    // 设置选中行
    setRowSelection() {
      if (this.results.length) {
        this.results.forEach((row) => {
          if (this.content.find((item) => item.id === row.id)) {
            this.$refs.multipleTable.toggleRowSelection(row, true);
          }
        });
      }
    },
    // 页面数量调整
    handleSizeChange(val) {
      this.query.pageSize = val;
      this.fetchList();
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, "pageIndex", val);
      this.fetchList();
    },
    handleClose() {
      this.$emit("close");
    },
    handleToChoose(row) {
      this.$emit('submit', row)
      this.handleClose()
    },
    handleSelectionChange(val) {
      let value = val
      this.selections = value;
    },
    submit() {
      this.$emit('submit', this.selections)
      this.handleClose()
    },
    formatePlatform_code(val) {
      const platform_code = {
        1: "小红书",
        2: "公众号",
        3: "微博",
        /*       4: "B站", */
        5: "知乎",
        /*       6: "抖音", */

      };
      return platform_code[val] || "";
    },
    formateType_code(val) {
      const type_code = {
        1: "机构",
        2: "课程",
        3: "学科",
        4: "院校",
      };
      return type_code[val] || "";
    },
  }
};
</script>

<style lang="less" scoped>
.dialog-wrap {
  .search-wrap {
    margin-bottom: -10px;
  }
  .result {
    margin-top: 10px;
  }
}
.footer {
  margin-top: 16px;
}
</style>
